import type { IconData } from '@stacksjs/iconify-core'

export const tagsF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m13.963 1.478l2.483 2.483a2 2 0 0 1 .498 2L15.71 9.99l-7.93 7.93L0 10.142l7.899-7.899l4.056-1.26a2 2 0 0 1 2.008.495m-3.71 6.19a1.5 1.5 0 1 0 2.121-2.122a1.5 1.5 0 0 0-2.121 2.121zm7.222 1.047q.813.032 1.178-.273a1.5 1.5 0 0 0 .185-2.113q-.164-.196-.527-.364a2 2 0 0 0-.538-1.848L16.05 2.395l2.269-.706a2 2 0 0 1 2.008.496l2.483 2.483a2 2 0 0 1 .498 2l-1.235 4.028l-7.93 7.931l-2.795-2.794l5.688-5.688z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default tagsF
